/*
 * @Description:
 * @Version: 2.0
 * @Autor: Lianzhidong
 * @Date: 2022-01-09 14:05:28
 * @LastEditors: Lianzhidong
 * @LastEditTime: 2022-03-15 22:41:07
 */
import { fetch, fetchGet } from "@/utils/request";

export default {
  //获取用户信息
  getUserInfo() {
    return fetchGet("/user/info");
  },

  //修改登录密码
  updatePassword(param) {
    return fetch("/user/updatePassword", param);
  },

  //修改操作密码
  updateHandlePassword(param) {
    return fetch("/updateDoublePW", param);
  },

  //修改手机、邮箱
  updateEmailAndPhone(param) {
    return fetch("/user/updateInfo", param);
  },

  //修改用户信息
  updateUserInfo(param) {
    return fetch("/user/updateUserInfo", param);
  },
};
